import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App.jsx';
import i18n from './i18n.js';

const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
const langParam = params?.get('lang');
const supported = (i18n.options?.supportedLngs || ['ua']).filter(l => l !== 'cimode');
if (langParam && supported.includes(langParam) && i18n.language !== langParam) {
  i18n.changeLanguage(langParam);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);
